module.exports = __webpack_public_path__ + "static/media/ic_proyectos_carretero_pin.6664ec88.svg";